import type { TestStepProps } from 'src/suitability/engine/types';
import { BLOCK2_QUESTIONS, type ConsilioAnswers } from './answers';
import { ScoredBlock } from './scored-block';

export const StepBlock2 = (props: TestStepProps<ConsilioAnswers>) => (
  <ScoredBlock {...props} stepKey="block2" questions={BLOCK2_QUESTIONS} />
);
